import { apiFGTS } from "../http/httpClient";
export interface createFGTSTransactionBody {
  value: number;
  customerId: string;
  CodigoTabela: string;
  CodigoProduto: number;
  CodigoEmpregador: number;
  CodigoOrg: number;
  Prazo: number;
  linkName: string;
  type?: string;
}

export interface createFGTSTransactionResponse {
  contract: string;
  value: number;
  status: string;
  seller: string;
  customer: string;
  _id: string;
  createdAt: string;
  updatedAt: string;
  __v: number;
}
export async function createFGTSTransaction(
  body: createFGTSTransactionBody,
) {
  const {
    linkName,
    type,
    value,
    customerId,
    CodigoTabela,
    CodigoProduto,
    CodigoEmpregador,
    CodigoOrg,
    Prazo,
  } = body;

  const { data } = await apiFGTS
    .post<createFGTSTransactionResponse>(
      `/self-hire/${linkName}/transaction`,
      {
        type: type || "FGTS",
        value,
        customerId,
        providerData: {
          CodigoTabela,
          CodigoProduto,
          CodigoEmpregador,
          CodigoOrg,
          Prazo,
        },
      },
    )
    .catch((err) => {
      throw err?.response?.data || err;
    });

  return data;
}
